import React from 'react'
import _ from 'lodash'
import { Link } from 'react-router-dom'
import {
  message, Menu, Dropdown, Icon, Button, Select,
} from 'antd'
import { SmallText, Div, Button as KonsysButton } from 'konsys-ui'
import history from '../../history'
import { theme } from '../../styles/_variables'
import { type, typeText } from '../../pages/client-page/constants'
import { P } from '../../pages/client-page/styled'
import PERMISSION from '../../constants/permissions'

const { color } = theme

export const CellText = props => (
  <P font='sarabun' padding='3px' {...props}>{props.children}</P>
)

export const HeaderLabel = props => (
  <SmallText bold color={color.coolGrey} font='sarabun' style={{ fontWeight: 700 }}>{props.children}</SmallText>
)

export const InputWithPlaceHolder = ({ handleChange }) => (
  <input placeholder='ค้นหา' onChange={e => handleChange(e.target.value)}/>
)

const menu = id => (
  <Div>
    <Menu>
      <Menu.Item key='view' disabled={!_.includes(window.perms, PERMISSION.VIEW_CLIENT)}>
        <Link target="_blank" to={`/client/view/${id}`}>
          ดูรายละเอียด
        </Link>
      </Menu.Item>
      <Menu.Item key='edit' disabled={!_.includes(window.perms, PERMISSION.UPDATE_CLIENT)}>
        <Link target="_blank" to={`/client/edit/${id}`}>
          แก้ไข
        </Link>
      </Menu.Item>
    </Menu>
  </Div>
)

export const TypeSelector = ({
  handleChange, filter, disabled,
}) => {
  const arr = [
    { value: type.CLIENT, text: typeText.CLIENT },
    { value: type.SUPPLIER, text: typeText.SUPPLIER },
  ]

  const filterer = filter ? _.concat({ value: 'ALL', text: 'ทั้งหมด' }, arr) : arr

  return (
    <Select
      disabled={disabled}
      dropdown
      defaultValue="ทั้งหมด"
      onChange={e => handleChange(e)}
    >
      {
        filterer.map(v => <Select.Option key={v.value} value={v.value}>{v.text}</Select.Option>)
      }
    </Select>
  )
}

export const DropdownSelector = ({
  data, handleChange, typeNameTh,
}) => {
  const width = typeNameTh ? '120px' : '100px'
  return (
    <Select
      defaultValue='ทั้งหมด'
      dropdown
      maxHeight='none'
      style={{ width }}
      onChange={e => (e === 'ALL' ? handleChange('') : handleChange(e))}
    >
    {
      data.map(v => <Select.Option key={v.value} value={v.value}>{v.text}</Select.Option>)
    }
    </Select>
  )
}

export const ActionSelector = ({ props: { original: { id } } }) => (
  <Dropdown overlay={menu(id)} trigger='click'>
    <Button>
      ดูรายละเอียด <Icon type="down" />
    </Button>
  </Dropdown>
)

export const Wrapper = props => (
  <Div
    display='block'
    width='100%'
    flexDirection='row'
    padding={props.padding || '40px 0'}
    justifyContent={props.center && 'center'}
    alignItems='flex-end'
    style={{ borderBottom: `1px solid ${color.paleGrey}`, overflow: props.overflow && 'auto' }}
  >
    {props.children}
  </Div>
)

export const ActionBar = ({
  loading, isAddMode, isViewMode, doAction, mutationVariables, props, disabled,
}) => (
  <Div
    position='fixed'
    height='72px'
    bottom='0'
    left='0'
    right='0'
    style={{ background: `${color.primaryColor}33` }}
    display='flex'
    justifyContent='flex-end'
    alignItems='center'
    padding='0 32px 0 0'
  >
    <KonsysButton
      loading={loading}
      disabled={loading || (isViewMode && !_.includes(window.perms, PERMISSION.UPDATE_CLIENT)) || disabled}
      text={isAddMode ? 'สร้างใหม่' : isViewMode ? 'แก้ไข' : 'บันทึก'}
      icon={isAddMode ? 'fas fa-plus' : isViewMode ? 'fas fa-edit' : 'fas fa-save'}
      inverse
      onClick={() => {
        if (isViewMode) history.push(`/client/edit/${props.match.params.id}`)
        else {
          doAction({
            variables: isAddMode ? { ...mutationVariables } : { id: parseInt(props.match.params.id, 10), ...mutationVariables },
          }).then(({ data }) => {
            const resp = isAddMode ? data.createCustomer : data.updateCustomer

            if (resp.success) {
              message.success(resp.message)

              if (isAddMode) history.push('/client')
              // else history.push(`/client/view/${props.match.params.id}`)
            } else message.error(resp.message)
          })
        }
      }}
    />
  </Div>
)
